module.exports = __webpack_public_path__ + "img/fprofile.d2992c15.svg";